import axios from 'axios';
import { buildUrl } from '../../helpers/utils';
import { urls } from './_datum.config';
import { toastSuccess } from '../../helpers/alert';

export const updateConfig = async (id, payload) => {
    const { data } = await axios.patch(buildUrl(urls.config_details, { id }), payload);
    toastSuccess('Config has been updated successfully');
    return data;
};

export const getProgramConfig = async (id) => {
    const { data } = await axios.get(buildUrl(urls.program_config, { id }));
    return data;
};

export const getConfig = async (id) => {
    const { data } = await axios.get(buildUrl(urls.config_details, { id }));
    return data;
};

export const getCoLendingMultipliers = (config, viewAs) => {
    if (viewAs !== 'borrower') {
        return {
            principal: config?.cam?.co_lending_split?.principal?.[viewAs]
                ? config?.cam?.co_lending_split?.principal?.[viewAs] * 0.01
                : 1,
            interest: config?.cam?.co_lending_split?.interest?.[viewAs]
                ? config?.cam?.co_lending_split?.interest?.[viewAs] * 0.01
                : 1,
            overdue: config?.cam?.co_lending_split?.overdue?.[viewAs]
                ? config?.cam?.co_lending_split?.overdue?.[viewAs] * 0.01
                : 1,
            penal: config?.cam?.co_lending_split?.penal?.[viewAs]
                ? config?.cam?.co_lending_split?.penal?.[viewAs] * 0.01
                : 1,
        };
    }
    return {
        principal: 1,
        interest: 1,
        overdue: 1,
        penal: 1,
    };
};
